import { GET_ALL_SUBSCRIPTION } from "./actions";

const initialState = {
  subscriptionList: {
    result: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },

  loading: true,
};

const subscriptionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_SUBSCRIPTION:
      return {
        ...state,
        subscriptionList: payload,
        loading: false,
      };

    default:
      return state;
  }
};
export default subscriptionReducer;
